import { Box, FormControlLabel, Switch } from "@mui/material";
import ExportMenu from "./ExportMenu";

export default function ArchivedAndExportControls({
  can,
  showArchived,
  onToggleShowArchived,
  initiatives,
  onImport,
}) {
  const styles = {
    root: {
      display: "flex",
      alignItems: "center",
      minHeight: 40,
      ml: -2,
      gap: 1,
    },
    label: {
      color: "background.tableHeaderText",
      fontWeight: 500,
      fontSize: "0.8125rem",
      textTransform: "none",
    },
  };

  return (
    <Box sx={styles.root}>
      {can("initiative:view_archived") && (
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={showArchived}
              onChange={(e) => onToggleShowArchived(e.target.checked)}
            />
          }
          label="Show Archived"
          slotProps={{ typography: { sx: styles.label } }}
        />
      )}
      <ExportMenu
        initiatives={initiatives}
        onImport={onImport}
        canExport={can("initiative:export")}
        canImport={can("initiative:import")}
      />
    </Box>
  );
}
